import {DesignExperimentComponent} from './DesignExperimentComponent';

export default DesignExperimentComponent;
